<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">设备状态</h5>
<!--      <a href="#" class="card-link text-primary">更多</a>-->
    </div>
    <div class="list-box mt-2">
      <!--              数据-->
      <div class="d-flex w-100 p-2 justify-content-between flex-shrink-0 dom-chat-box" ref="chart">

      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, defineExpose, onUnmounted, onBeforeUnmount, computed, defineProps, watch} from "vue";
import {getListMock} from "@/api/test";
import * as echarts from 'echarts'
import {useStore} from 'vuex'
const store = useStore()
const total_device = computed(()=> store.state.homeModel.total_device)//设备总数
const device_count_in_use = computed(()=> store.state.homeModel.device_count_in_use)//设备在用数量
const props = defineProps({
  loading:{
    default:true
  }
})
watch(()=>props.loading,(n,o)=>{
  if(n){
    showLoading()
  }else{
    hideLoading()
  }
})
const chart = ref()
let mychart = null
let options = {
  title: {
    text: "",
  },
  tooltip: {
    trigger: 'item'
  },
  legend:{
    orient: 'vertical',
    left: 'left'
  },
  series: [
    {
      name: '部件合格统计',
      type: 'pie',
      radius: ['40%', '80%'],
      color: [
        // '#f8c657',
        '#536fc4',
        '#9ede7f',
       ],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 10,
        borderColor: '#fff',
        borderWidth: 2
      },
      label: {
        show: true,
        position: 'center',
        fontWeight: 'bold',
        formatter:function (){
          return `{title|设备总数} \n {sum|30}`
        },
        rich: {
          title: {
            fontSize: 16,
            fontWeight: 500,
            height:30,
            lineHeight:30,
            color: '#000'
          },
          sum: {
            fontSize: 14,
            fontWeight: 400,
            height:30,
            lineHeight:30,
            color: '#000'
          }
        }
      },
      // emphasis: {
      //   label: {
      //     show: true,
      //     fontSize: 20,
      //     fontWeight: 'bold',
      //     formatter:function (){
      //       return "xxx"
      //     }
      //   }
      // },
      labelLine: {
        show: false
      },
      data: [
        { value: 0, name: '空闲' },
        // { value: 10, name: '已预约' },
        { value: 0, name: '在使用' },
      ]
    }
  ]
};
onMounted(()=>{
  initChat()
  window.addEventListener('resize', onwindowresize, false)
})
onBeforeUnmount(()=>{
  if (mychart != null && mychart.dispose) {
    mychart.dispose();
  }
})
onUnmounted(()=>{
  window.removeEventListener('resize', onwindowresize)
  if (mychart != null && mychart.dispose) {
    mychart.dispose();
  }
})
// 初始化
const initChat =async ()=>{
  if(!chart.value){
    return
  }
  mychart = echarts.init(chart.value)
  if(props.loading){
    mychart.showLoading()
  }else{
    resetChatData()
  }
  // mychart && mychart.showLoading()
  // await getListMock()
  // mychart && mychart.hideLoading()
  // mychart && mychart.setOption(options)
}


// 开启loading
const showLoading = ()=>{
  if (!mychart) {
    initChat()
  }
  mychart.showLoading()
}
// 关闭loading
const hideLoading = ()=>{
  if (!mychart) {
    initChat()
  }
  mychart.hideLoading()
  resetChatData()
}

const onwindowresize = ()=>{
  if (mychart) {
    mychart.resize()
  }
}
const resetChatData = ()=>{
  const notUse = total_device.value - device_count_in_use.value<=0?0:total_device.value - device_count_in_use.value
  const data = [
    { value: notUse, name: '空闲' },
    { value: device_count_in_use.value, name: '在使用' },
  ]
  options.series[0].data = data
  options.series[0].label.formatter=function (){
    return `{title|设备总数} \n {sum|${total_device.value}}`
  },
  mychart.hideLoading()
  mychart.setOption(options)
  // mychart && mychart.setOption({
  //   series:{
  //     data:data
  //   }
  // })
}
defineExpose({
  resetChatData
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";
</style>
